import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Row,
  Col,
  Input,
  Form,
  Button,
  FormGroup,
  Label,
  FormText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import questionnaireService from "../../services/questionnaireService";
import alertActions from "../../actions/alertActions";

const QuestionnaireModal = (props) => {
  const dispatch = useDispatch();
  const {
    buttonLabel,
    color,
    userId,
    qId,
    modalTitle,
    readOnly,
    getQuestionnaireButton,
  } = props;

  const [questionnaire, setQuestionnaire] = useState({});
  const [formState, setFormState] = useState([]);
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    if (props) {
      console.log(props.hasCurrentQuestionnaire);
      if (!props.hasCurrentQuestionnaire) {
        questionnaireService
          .getNewQuestionnaireStaff(userId)
          .then((payload) => {
            setQuestionnaire(payload);
            setFormState(payload.formVmList);
          });
      } else {
        questionnaireService
          .getCurrentQuestionnaireStaff(userId)
          .then((payload) => {
            setQuestionnaire(payload);
            setFormState(payload.formVmList);
          });
      }
    }
  }, [qId, props, userId]); //If we pass an empty array to useEffect, it’s only executed after the first render.

  const handleChange = (evt) => {
    //map target
    const { target } = evt;
    //create state dupe
    var dummyFormState = formState.slice();
    //set index
    var index = parseInt(target.name);
    //get object
    var arrayObject = dummyFormState[parseInt(index)];
    // update object
    arrayObject = { ...arrayObject, answerText: target.value };
    //replace original object with copy in formState
    dummyFormState[index] = arrayObject;
    //update state
    setFormState(dummyFormState);
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    const newObj = { formVms: formState, justIdVm: { id: userId } };
    if (props.hasCurrentQuestionnaire) {
      if (getQuestionnaireButton !== null) {
        questionnaireService
          .updateCurrentQuestionnaireStaff(newObj)
          .then(() => {
            getQuestionnaireButton(userId);
            dispatch(
              alertActions.success("Sucessfully updated questionnaire.")
            );
          });
      } else {
        questionnaireService
          .updateCurrentQuestionnaireStaff(newObj)
          .then(() =>
            dispatch(alertActions.success("Sucessfully updated questionnaire."))
          );
      }
    } else {
      if (getQuestionnaireButton !== null) {
        questionnaireService.submitNewQuestionnaireStaff(newObj).then(() => {
          getQuestionnaireButton(userId);
          dispatch(alertActions.success("Sucessfully created questionnaire."));
        });
      } else {
        questionnaireService
          .submitNewQuestionnaireStaff(newObj)
          .then(() =>
            dispatch(alertActions.success("Sucessfully created questionnaire."))
          );
      }
      toggle();
    }
    //console.log(formState, userId);
  };

  const getDropDownMenuItems = (dropDownMenuName) => {
    //console.log(dropDownMenuName);
    const getAll = questionnaire.dropDownGroups.filter(
      (x) => x.dropDownGroupName === dropDownMenuName
    );
    return getAll;
  };

  return (
    <React.Fragment>
      <Button color={color} onClick={toggle}>
        {buttonLabel}
      </Button>
      <Modal isOpen={modal} toggle={toggle} size={"lg"}>
        <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={12}>
              <h2>
                {" "}
                {!props.hasCurrentQuestionnaire ? "New " : "Edit "}{" "}
                {questionnaire ? questionnaire.questionnaireName : ""}
              </h2>
            </Col>
            <Col xs={12}>
              <Form>
                {formState.map((qq, i) => (
                  <FormGroup row key={qq.questionnaireQuestionId}>
                    <Label sm={12}>{qq.questionText}</Label>
                    <Col sm={12}>
                      {!qq.yesNo && qq.dropDownGroupName === "" && (
                        <React.Fragment>
                          <Input
                            type="textarea"
                            name={i}
                            value={formState[i].answerText}
                            onChange={(evt) => {
                              handleChange(evt);
                            }}
                            readOnly={readOnly}
                          />
                          <br />
                        </React.Fragment>
                      )}
                      {!qq.yesNo && qq.dropDownGroupName !== "" && (
                        <React.Fragment>
                          <FormText>Select an option</FormText>
                          <Input
                            type="select"
                            name={i}
                            value={formState[i].answerText}
                            onChange={(evt) => {
                              handleChange(evt);
                            }}
                            readOnly={readOnly}
                          >
                            <option value="">Select an option below</option>
                            {getDropDownMenuItems(qq.dropDownGroupName).map(
                              (x) => (
                                <option
                                  value={x.groupItemName}
                                  key={x.groupItemName}
                                >
                                  {x.groupItemName} - {x.groupItemDescription}
                                </option>
                              )
                            )}
                          </Input>

                          <br />
                        </React.Fragment>
                      )}
                      {qq.yesNo && (
                        <React.Fragment>
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="radio"
                                name={i}
                                checked={
                                  formState[i].answerText === "false" ||
                                  formState[i].answerText === ""
                                }
                                value="false"
                                onChange={(evt) => {
                                  handleChange(evt);
                                }}
                                readOnly={readOnly}
                              />{" "}
                              No
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="radio"
                                name={i}
                                checked={formState[i].answerText === "true"}
                                value="true"
                                onChange={(evt) => {
                                  handleChange(evt);
                                }}
                                readOnly={readOnly}
                              />{" "}
                              Yes
                            </Label>
                          </FormGroup>
                          <br />
                        </React.Fragment>
                      )}
                    </Col>
                  </FormGroup>
                ))}
                {!readOnly && (
                  <Button type="button" onClick={(evt) => handleSubmit(evt)}>
                    Submit
                  </Button>
                )}
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default QuestionnaireModal;
